module.exports = __webpack_public_path__ + "static/media/leave-close.e6a4bb18.svg";